import { IS_DEV } from "@/constants"
import { useStore } from "zustand"
import { devtools, subscribeWithSelector } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"
import { createStore } from "zustand/vanilla"

type DefineStoreArgs<T> = {
  initialState: T
  storeName: string
  devToolsEnabled?: boolean
}

export type SelectorFn<T, U> = (state: T) => U

export const defineZustandStore = <T>(args: DefineStoreArgs<T>) => {
  const store = createStore<T>()(
    devtools(immer(subscribeWithSelector((_set, _get) => args.initialState)), {
      name: args.storeName,
      enabled: args.devToolsEnabled ?? IS_DEV,
    }),
  )

  const set = store.setState.bind(store)

  const useStoreWithSelector = <U>(selector: SelectorFn<T, U>) => useStore(store, selector)

  return { store, set, useStoreWithSelector, useStore: () => useStore(store) }
}
